module.exports = __webpack_public_path__ + "static/fonts/youzhihei.1726685.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/youzhihei.ttf
// module id = gaFx
// module chunks = 1